import { useQuery } from "@tanstack/react-query";
import { Experiment } from "@worldwidewebb/client-quests";
import { getExperiments } from "../../api/quests/experiments";

export default function useExperiments() {
  const {
    isLoading,
    isFetching,
    error,
    data: experiments,
  } = useQuery<Experiment[]>({
    queryKey: ["lut"],
    queryFn: () => getExperiments(),
  });

  return {
    isLoading: isLoading || isFetching,
    error,
    experiments,
  };
}
